import API from './utils/API'

const api = new API()
const prefix = '/mfa'

const sendMfaCode = (data) =>
  api
    .callApi({
      url: `${prefix}/send`,
      method: 'post',
      data,
    })
    .then((result) => result.data.result)

const verifyMfaCode = (data) =>
  api
    .callApi({
      url: `${prefix}/verify`,
      method: 'post',
      data,
    })
    .then((result) => result.data.result)

const abandonMfaSession = () =>
  api.callApi({
    url: `${prefix}/abandon`,
    method: 'post',
  })

export default {
  sendMfaCode,
  verifyMfaCode,
  abandonMfaSession,
}
